/* eslint-disable no-param-reassign */
export default () => {
  const pairs = window.location.search.slice(1).split('&');

  return pairs.reduce((result, pair) => {
    const splitPairs = pair.split('=');
    result[splitPairs[0]] = decodeURIComponent(splitPairs[1] || '');

    return result;
  }, {});
}



// WEBPACK FOOTER //
// ./src/features/common/util/queryParamsToObj.js